/**
 * 🚨 This file is generated by scripts/zendesk.ts. Don't modify it manually!
 */

export const requestLetterCustomFieldsNZ = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390538 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
  "DOB DD/MM/YYYY": { prod: 360006254998, nonProd: 360010666198 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  "NZ Products": { prod: 360006184317, nonProd: 360010669818 },
  "Letters - NZ/GEM": { prod: 360011640678, nonProd: 360025385437 },
  "Date of Payment": { prod: 360006046917, nonProd: 360010668218 },
  "Payment Amount": { prod: 360006046937, nonProd: 360010669378 },
  "Date of final payment": { prod: 360006046957, nonProd: 360010670598 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  Type: { prod: 360013721973, nonProd: "NA" },
  Priority: { prod: 360013721993, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
};

export const requestLetterCustomFieldsAu = {
  Status: { prod: 360013721953, nonProd: "NA" },
  Group: { prod: 360013722013, nonProd: 360004390118 },
  Assignee: { prod: 360013722033, nonProd: 376888316957 },
  "Customers first name": { prod: 360006712378, nonProd: 360010706397 },
  "Surname  (as it appears on ID)": {
    prod: 360026751773,
    nonProd: 360010709557,
  },
  "Account Holder's Full Name": { prod: 360006010718, nonProd: 360010707817 },
  "DOB DD/MM/YYYY": { prod: 360006254998, nonProd: 360010666198 },
  DOB: { prod: 360022862154, nonProd: 360010707057 },
  "Last 4 digits": { prod: 360006081238, nonProd: 360010709017 },
  "Mobile Number": { prod: 360006010038, nonProd: 360010707337 },
  "Relationship to account": { prod: 360006009878, nonProd: 360010669558 },
  "Security question": { prod: 360006239578, nonProd: 360010667978 },
  "Value field": { prod: 360006271557, nonProd: "NA" },
  "Date field": { prod: 360006271577, nonProd: "NA" },
  Product: { prod: 360006007178, nonProd: 360010710517 },
  "Make of Vehicle": { prod: 360010631737, nonProd: 360010666518 },
  "Model of Vehicle": { prod: 360010631757, nonProd: 360010667318 },
  "Colour of Vehicle": { prod: 360010593238, nonProd: 360010708977 },
  Address: { prod: 360005089238, nonProd: 360010708997 },
  Letters: { prod: 360006023198, nonProd: 360010709837 },
  "Date of Payment": { prod: 360006046917, nonProd: 360010668218 },
  "Payment Amount": { prod: 360006046937, nonProd: 360010669378 },
  "ATP or POA Full Name": { prod: 360006032317, nonProd: 360010667918 },
  "Privacy Acknowledgement": { prod: 360006023478, nonProd: 360010666398 },
  "Email Contact ON FILE": { prod: 360005939057, nonProd: "NA" },
  "Mobile Contact ON FILE": { prod: 360005939037, nonProd: "NA" },
  "Account number ON FILE": { prod: 360004901638, nonProd: "NA" },
  "Product Name ON FILE": { prod: 360005938977, nonProd: "NA" },
  "Account Position ON FILE": { prod: 360005807577, nonProd: "NA" },
  "Manual Input ON FILE": { prod: 360005796038, nonProd: "NA" },
  "Application ID ON FILE": { prod: 360005922518, nonProd: "NA" },
  Subject: { prod: 360013721913, nonProd: "NA" },
  Description: { prod: 360013721933, nonProd: "NA" },
  Type: { prod: 360013721973, nonProd: "NA" },
  Priority: { prod: 360013721993, nonProd: "NA" },
  "Time spent last update (sec)": { prod: 360021307894, nonProd: "NA" },
  "Total time spent (sec)": { prod: 360021307874, nonProd: "NA" },
};

export const nzProducts = {
  "Gem Visa": { prod: "gem_visa_nz", nonProd: "gem_visa_nz" },
  "Gem Essential": { prod: "gem_essential_nz", nonProd: "gem_essential_nz" },
  "Gem CreditLine": {
    prod: "gem_credit_line_nz",
    nonProd: "gem_credit_line_nz",
  },
  "Gem Personal Loan": {
    prod: "personal_loan_nz",
    nonProd: "personal_loan_nz",
  },
  "Gem Motor Loan": { prod: "gem_motor_loan", nonProd: "gem_motor_loan" },
};

export const nzLetters = {
  "Account Closure": {
    nonProd: "account_closure_letters_dropdown",
    prod: "account_closure_letters_dropdown",
    isEnabled: false,
  },
  "Credit Limit Decrease": {
    nonProd: "credit_limit_decrease_letters_dropdown",
    prod: "credit_limit_decrease_letters_dropdown",
    isEnabled: true,
  },
  "Account Balance": {
    nonProd: "account_balance_letters_dropdown",
    prod: "account_balance_letters_dropdown",
    isEnabled: true,
  },
  "No Activity Letter": {
    nonProd: "no_activity_letter_letters_dropdown",
    prod: "no_activity_letter_letters_dropdown",
    isEnabled: true,
  },
  "Payment Received": {
    nonProd: "payment_received_letters_dropdown",
    prod: "payment_received_letters_dropdown",
    isEnabled: false,
  },
  "Payout Figure": {
    nonProd: "payout_figure_letters_dropdown",
    prod: "payout_figure_letters_dropdown",
    isEnabled: false,
  },
};

export const openCCletterTypes = Object.keys(nzLetters)
  .filter((key) => nzLetters[key].isEnabled)
  .map((key) => ({
    label: key,
    value: key,
  }));

export const closedCCletterTypes = [
  {
    label: "Account closure",
    value: "Account closure",
  },
];
